'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindings = exports.template = undefined;
exports.controller = controller;
exports.link = link;

var _menu = require('site/menu.scss');

var styles = _interopRequireWildcard(_menu);

var _close = require('assets/close.svg');

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var template = exports.template = '\n  <a href="" ng-click="ctrl.onClose()" class="' + styles.close + '">' + _close2.default + '</a>\n  <a class="' + styles.link + '" href="" ng-click="ctrl.onSelection({section:\'CLIENTS\'})">CLIENTS</a>\n  <a class="' + styles.link + '" href="" ng-click="ctrl.onSelection({section:\'TEAM\'})">TEAM</a>\n  <a class="' + styles.link + '" href="" ng-click="ctrl.onSelection({section:\'ABOUT\'})">ABOUT</a>\n  <a class="' + styles.link + '" href="" ng-click="ctrl.onSelection({section:\'PRESS\'})">PRESS</a>\n  <a class="' + styles.link + '" href="" ng-click="ctrl.onSelection({section:\'CONTACT\'})">CONTACT</a>\n';

var bindings = exports.bindings = {
  onClose: '&',
  onSelection: '&'
};

function controller() {
  var ctrl = this;
  ctrl.id = ctrl.id || 'site-menu';
}

function link($scope, $element, $attrs, ctrl) {}

var $directive = {
  scope: {},
  transclude: true
};

if(typeof bindings !== 'undefined') { $directive.bindToController = bindings }

angular.extend($directive, module.exports);

$directive.compile = function($element) {
  if(styles && styles.component) {
    $element.addClass(styles.component)
  }
  if(typeof(compile) === 'function') {
    return compile.apply(this, Array.prototype.slice.call(arguments));
  } else if(typeof(link) === 'function') {
    return {post: link};
  }
};

var $module = require('utils/module-registry').getModule('site');

if (controller) {
  $directive.controller = 'siteMenuCtrl as ctrl';
  $module.controller('siteMenuCtrl', controller);
}

$module.directive('siteMenu', function() { return $directive });


/*****************
 ** WEBPACK FOOTER
 ** ./site/menu.directive.js
 ** module id = 31
 ** module chunks = 0
 **/